import * as React from 'react'
import { useCallback } from 'react'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { bulkCloseWinOpportunities } from '@user/store/opportunity'
import { BulkCloseWinForm } from '@user/components/xGrid/atoms/BulkActions/BulkActionCloseWin/BulkCloseWinForm/BulkCloseWinForm'
import { BulkCloseWinOpportunityInput } from '@user/components/xGrid/atoms/BulkActions/typings/BulkCloseWin/BulkCloseWinOpportunityInput'

export const BulkCloseWinOpps: React.FC = () => {
  const dispatch = useAppDispatch()

  const validateRows = useCallback(
    async (model: BulkCloseWinOpportunityInput) => {
      const result = await dispatch(bulkCloseWinOpportunities({ model }))
      if (bulkCloseWinOpportunities.fulfilled.match(result))
        return result.payload.model
    },
    [dispatch],
  )

  const onSubmit = useCallback(
    async (model: BulkCloseWinOpportunityInput) =>
      void (await dispatch(
        bulkCloseWinOpportunities({ mode: 'commit', model }),
      )),
    [dispatch],
  )

  return (
    <BulkCloseWinForm submitHandler={onSubmit} validateRows={validateRows} />
  )
}
BulkCloseWinOpps.displayName = 'BulkCloseWinOpps'
